export default __webpack_public_path__ + "static/media/Simple-Line-Icons.dev.2b9b7db3.svg";